import { useFormattedNumber } from "./useFormattedNumber";

/**
 * Returns the given distance in a formatted string and converted to the {@link User}'s preferred
 * measurement system.
 *
 * @param kilometers - The distance in kilometers.
 * @param precision - The number of decimal places to display (default: 0)
 * @returns The formatted distance.
 */
export function useFormattedDistance(kilometers?: number, precision = 0) {
  const metersFormatted = useFormattedNumber((kilometers ?? 0) * 1000, precision);
  const kilometersFormatted = useFormattedNumber(kilometers, precision);

  if (kilometers === undefined) {
    return kilometers;
  }

  if (kilometers < 1) {
    return `${metersFormatted} m`;
  } else {
    return `${kilometersFormatted} km`;
  }
}
